
import { Options, Vue } from 'vue-class-component';
import { ProviderAuthClient } from '@/services/DueDiligenceServices';
import { LoginServices } from '@/services/LoginServices';
import InfoModal from '@/components/modals/infoModal.vue';
import * as DDM from '@/dueDiligenceModels';

@Options({})
export default class ProviderRegistration extends Vue {

    model: DDM.RegisterProviderVM = new DDM.RegisterProviderVM();
    tokenInfo: DDM.ValidateTokenResponse = new DDM.ValidateTokenResponse();
    loading: boolean = true;
    tokenValid: boolean = false;
    alreadyRegistered: boolean = false;

    created() {
        let token = this.$route.query.token as string;
        if (!token) {
            this.loading = false;
            return;
        }

        this.model.token = token;
        ProviderAuthClient.validateInvitationToken(token)
        .then(x => {
            this.tokenInfo = x;
            this.tokenValid = x.valid;
            this.alreadyRegistered = x.alreadyRegistered;
            this.model.preferredCulture = x.preferredCulture || "en-US";
            this.loading = false;
        })
        .catch(() => {
            this.loading = false;
        });
    }

    get passwordMismatch(): boolean {
        return this.model.password.length > 0 && this.model.confirmPassword.length > 0 && this.model.password !== this.model.confirmPassword;
    }

    get registerDisabled(): boolean {
        return !this.model.password || !this.model.confirmPassword || this.model.password !== this.model.confirmPassword;
    }

    register() {
        ProviderAuthClient.registerFromInvitation(this.model)
        .then(x => {
            LoginServices.ProviderLoginCallback(x);
        })
        .catch(err => {
            this.$opModal.show(InfoModal, {
                text: this.$localizationService.getLocalizedValue("Error", "Error"),
                subtitle: err.Message || err,
                deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                denyCb: () => { this.$opModal.closeLast(); }
            });
        });
    }
}
